import { render, staticRenderFns } from "./ZigZag.vue?vue&type=template&id=116d742b&scoped=true&"
import script from "./ZigZag.vue?vue&type=script&lang=js&"
export * from "./ZigZag.vue?vue&type=script&lang=js&"
import style0 from "./ZigZag.vue?vue&type=style&index=0&id=116d742b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116d742b",
  null
  
)

export default component.exports